import React from 'react'
import ReactDOM from 'react-dom'
import { context } from '@tools/wr-catalog-base'
import TemplateComponent from './template'

export default async (props) => {
  const container = document.createElement('iframe')
  const css = (await fetch('/sow-assets/sow-pdf.css').then((v) => v.text())).replace(
    /\{\{assetHost\}\}/gi,
    process.env.NODE_ENV === 'development' ? 'https://ptc-v2.catalogs.dev.workrails.com' : window.location.origin,
  )

  const content = await TemplateComponent({ ...props, region: context.utils.getRegionName(), css })
  return new Promise((resolve, reject) => {
    try {
      ReactDOM.render(content, container, () => {
        resolve(container.innerHTML)
      })
    } catch (err) {
      reject(err)
    }
  })
}
